export default "__VITE_ASSET__9caafff2__"